import { GET_ROLES_REQUEST, GET_ROLES_SUCCESS, GET_ROLES_FAILURE, GetRolesActionTypes, GetRolesState } from './types';

const defaultState: GetRolesState = {
  isLoading: false,
  errorMessage: "",
};

export default function getRoles(state = defaultState, action: GetRolesActionTypes): GetRolesState {
  switch (action.type) {
    case GET_ROLES_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_ROLES_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
